module.exports = __webpack_public_path__ + "static/Banner-17-ac0ba973a80bb8e455c15a298596459d.png";